const defaultState = () => ({
  form: {
    idSkill: undefined,
    idSubSkill: undefined,
    tactic: undefined,
    locale: 'pt_BR',
    id: undefined,
    name: undefined,
    hasSubtechnique: [],
    aboveThan: undefined,
    platforms: [],
    permission: undefined,
    version: undefined,
    permaLinkVersion: undefined,
    liveLinkVersion: undefined,
    createdAt: undefined,
    updatedAt: undefined,
    dataSources: [],
    description: undefined
  },
  idCompanyFilter: undefined
})
export default {
  namespaced: true,
  state: defaultState(),
  getters: {
    form: (state) => state.form,
    idCompanyFilter: (state) => state.idCompanyFilter
  },
  mutations: {
    form: (state, { id, input }) => {
      state.form[id] = input
    },
    fullForm: (state, payload) => {
      state.form = payload
    },
    resetForm: (state) => {
      state.form = defaultState()['form']
    },
    idCompanyUpdate: (state, payload) => {
      state.idCompanyFilter = payload
    }
  }
}

